
















































































import { InvitationData } from '@beyondview/firebase-client-8';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { MetaInfo } from 'vue-meta';

import { db, auth } from '@/firebase';

import JoinForm from '@/components/forms/JoinForm.vue';
import LoginForm from '@/components/forms/LoginForm.vue';

const invitations = db.collection( 'invitations' );

interface ComponentData {
	invitation: InvitationData | null,
	joining: boolean,
	errorMessage: string | null
}

export default Vue.extend( {
	components: {
		JoinForm,
		LoginForm
	},
	data(): ComponentData {
		return {
			invitation: null,
			joining: false,
			errorMessage: null
		};
	},
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.join.join' )}`
		};
	},
	computed: {
		...mapGetters( [ 'hasAuth', 'user' ] )
	},
	async created() {
		const { id: invitationId } = this.$route.params;
		const maxRefDepth = this.hasAuth ? 1 : 0;
		try {
			await this.$bind( 'invitation', invitations.doc( invitationId ), { maxRefDepth } );
		} catch {
			this.errorMessage = 'Error accesing invitation.';
			return;
		}
		if ( !this.invitation || this.invitation.status === 'ACCEPTED' ) {
			this.errorMessage = 'Invalid or expired invitation.';
		}
	},
	methods: {
		async handleAccept() {
			this.joining = true;
			await this.$store.dispatch( 'join', { invitationId: this.invitation?.id } );
			await this.$router.push( '/' );
		},
		handleLogin() {
			this.joining = true;
		},
		handleJoin() {
			this.joining = true;
		},
		async handleLogout() {
			await auth.signOut();
		}
	}
} );
